import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageViewByPath, trackPageDuration } from 'gaTracking';

// Module-level variable: persists across navigations within the same session
let previousPath = null;

export const usePageTracking = (pageName) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const enterTimeRef = useRef(null);

  useEffect(() => {
    // Snapshot previous path before updating
    const prevPath = previousPath;
    previousPath = currentPath;
    enterTimeRef.current = Date.now();

    trackPageViewByPath({
      page_name: pageName,
      page_path: currentPath,
      previous_path: prevPath,
    });

    return () => {
      const durationSeconds = Math.round(
        (Date.now() - enterTimeRef.current) / 1000
      );
      trackPageDuration({
        page_name: pageName,
        page_path: currentPath,
        previous_path: prevPath,
        duration_seconds: durationSeconds,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPath]);
};
